// extracted by mini-css-extract-plugin
export default {"inputContainer":"SimpleSearchInput_inputContainer__Pq4Pi","iconContainer":"SimpleSearchInput_iconContainer__UhicV","input":"SimpleSearchInput_input__nB9yo"};